import { connect } from 'react-redux';
import { selectActiveVenue } from 'selectors/general';
import AutoSyncStatus from './AutoSyncStatus';

const mapStateToProps = state => {
  const { autosyncStatus, autosyncSource, autosyncLastSyncDatetime, venueSource } = selectActiveVenue(state);

  return {
    autosyncStatus,
    autosyncSource,
    autosyncLastSyncDatetime,
    venueSource,
  };
};

export default connect(mapStateToProps)(AutoSyncStatus);
